import { render, staticRenderFns } from "./PageEditorFileInput.vue?vue&type=template&id=2f4e7f3f&scoped=true"
import script from "./PageEditorFileInput.vue?vue&type=script&lang=js"
export * from "./PageEditorFileInput.vue?vue&type=script&lang=js"
import style0 from "./PageEditorFileInput.vue?vue&type=style&index=0&id=2f4e7f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e7f3f",
  null
  
)

export default component.exports